import { Routes } from '@angular/router';
import { EmptyLayoutComponent } from '@core/layouts/empty/empty-layout.component';
import { AbookLayoutComponent } from './core/layouts/abook-layout/abook-layout-component';
import { AuthorizationGuard } from '@core/authentication/auth-guard';
import { provideDemoRoutes } from './features/demo-ui/demo.provider';

export const routes: Routes = [
  /*
    Default route
  	*/
  { path: '', redirectTo: 'authentication', pathMatch: 'full' },

  /*
    Auth routes + layout
  	*/
  {
    path: '',
    component: EmptyLayoutComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('@core/authentication/authentication.routes').then((m) => m.authenticationRoutes),
      },
    ],
  },
  /*
    Front-channel logout from abook-auth: framed in a zero-size iframe, never navigated to by a
    person. Top level, outside AuthorizationGuard and the layouts, so it renders nothing.
  	*/
  {
    path: 'signout-frontchannel',
    loadComponent: () =>
      import('@core/authentication/signout-frontchannel/signout-frontchannel.component').then(
        (m) => m.SignoutFrontchannelComponent,
      ),
  },
  /*
    Main routes + dynamic layouts
  	*/
  {
    path: '',
    component: AbookLayoutComponent,
    canActivate: [AuthorizationGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
      {
        path: 'booking',
        loadChildren: () => import('./features/booking/booking-router.module').then((m) => m.BookingRouterModule),
      },
      // {
      //   path: 'locker-rooms',
      //   loadChildren: () => import('./features/locker-rooms/locker-rooms.routes').then((m) => m.lockerRoomsRoutes),
      // },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users-router.module').then((m) => m.UsersRouterModule),
      },
      {
        path: 'schedules',
        loadChildren: () => import('./features/schedules/schedules-router.module').then((m) => m.SchedulesRouterModule),
      },
      {
        path: 'resources',
        loadChildren: () => import('./features/resources/resources.routes').then((m) => m.resourcesRoutes),
      },
      {
        path: 'opening-hours',
        loadChildren: () =>
          import('./features/opening-hours/opening-hours.routes').then((m) => m.openingHoursRoutes),
      },
      {
        path: 'codes',
        loadChildren: () => import('./features/codes/codes-router.module').then((m) => m.CodesRouterModule),
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/roles/roles-router.module').then((m) => m.RolesRouterModule),
      },
      {
        path: 'template',
        loadChildren: () => import('./features/template/template.routes').then((m) => m.templateRoutes),
      },
      {
        path: 'cms',
        loadChildren: () => import('./features/cms/cms.routes').then((m) => m.cmsRoutes),
      },
      {
        path: 'tags',
        loadChildren: () => import('./features/tags/tags-router.module').then((m) => m.TagsRouterModule),
      },
      {
        path: 'entries',
        loadChildren: () => import('./features/entries/entries.routes').then((m) => m.entriesRoutes),
      },
      {
        path: 'associations',
        loadChildren: () => import('./features/associations/associations.routes').then((m) => m.associationsRoutes),
      },
      {
        path: 'checkout',
        loadChildren: () => import('./features/checkout/checkout.routes').then((m) => m.checkoutRoutes),
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes').then((m) => m.settingsRoutes),
      },
      {
        path: 'subscriptions',
        loadChildren: () => import('./features/subscriptions/subscriptions.routes').then((m) => m.subscriptionRoutes),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.routes').then((m) => m.profileRoutes),
      },
      {
        path: 'help',
        loadChildren: () => import('./features/help/help.routes').then((m) => m.helpRoutes),
      },
      // Note! provideDemoRoutes are NOT included in production bundle (angular.json file replacement strategy)
      ...provideDemoRoutes(),
    ],
  },
  /*
    Undefined routes — a wrong address is not a permission problem, so it does not go to
    /authentication/unauthorized, which now explains itself.
  */
  {
    path: '**',
    component: EmptyLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('@core/pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
];
